import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { XAlertService } from '@core/services/x-alert.service';
import { ClipboardService } from 'ngx-clipboard';
import { TuiButton, TuiButtonOptions } from '@taiga-ui/core';
import {
  TextCopierTranslations,
  TextCopierTranslationsPayload,
} from '../../types';
import { OutkeepTranslateService } from '@core/services/outkeep-translate.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'x-text-copier',
  imports: [TuiButton],
  templateUrl: './text-copier.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextCopierComponent implements OnInit {
  private readonly clipboardService = inject(ClipboardService);
  private readonly xAlertService = inject(XAlertService);
  private readonly outkeepTranslateService = inject(OutkeepTranslateService);
  private readonly destroyRef = inject(DestroyRef);
  translates: TextCopierTranslationsPayload = {
    [TextCopierTranslations.Copied]: 'Скопировано',
    [TextCopierTranslations.NotFoundToCopy]: 'Нечего копировать',
  };

  $textToCopy = input.required<string>({ alias: 'textToCopy' });
  $size = input<TuiButtonOptions['size']>('m', { alias: 'size' });
  $appearance = input<string>('blue', {
    alias: 'appearance',
  });

  ngOnInit(): void {
    this.outkeepTranslateService
      .translate(Object.values(TextCopierTranslations))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(translates => (this.translates = translates));
  }

  copyToClipboard() {
    if (!this.$textToCopy()) {
      this.xAlertService.showMessage(
        this.translates[TextCopierTranslations.NotFoundToCopy],
        {
          appearance: 'warning',
          autoClose: 2000,
        },
      );

      return;
    }
    this.clipboardService.copy(this.$textToCopy());
    this.xAlertService.showMessage(
      this.translates[TextCopierTranslations.Copied],
      {
        appearance: 'positive',
        autoClose: 2000,
      },
    );
  }
}
